import { Directive, HostListener, inject } from '@angular/core';
import { ContentModel } from '@libs/cms/models';
import { GTMPageBlockTrackingModel } from '@libs/shared/models';
import {
  CONTENT_TRACKING_CONTEXT,
  CONTENT_TRACKING_DATA,
  ContentTrackingContext,
  ContentTrackingData,
  TrackingDataFields,
} from '../context';
import { TrackingMapperService } from '../mapper';
import { TrackingGoogleService } from '../services';

@Directive({
  selector: '[uiPageBlockLinkClick]',
})
export class PageBlockLinkClickDirective {
  public readonly contentTrackingContext: ContentTrackingContext | null = inject(CONTENT_TRACKING_CONTEXT, { optional: true });
  public readonly contentTrackingData: ContentTrackingData | null = inject(CONTENT_TRACKING_DATA, { optional: true });
  private readonly trackingMapper: TrackingMapperService = inject(TrackingMapperService);

  public constructor(
    private readonly trackingService: TrackingGoogleService,
  ) {
  }

  @HostListener('click')
  public onClick(): void {
    const context: ContentModel | undefined = this.contentTrackingContext?.data();
    const trackingData: TrackingDataFields | undefined = this.contentTrackingData?.data();

    if (!context) {
      return;
    }

    const event: GTMPageBlockTrackingModel = this.trackingMapper.mapPageBlockToPageBlockTracking(context, trackingData);

    this.trackingService.trackPageBlockClickEvent({ ...event, ...{ click_type: 'link' } });
  }
}
